// import Vezgo from 'vezgo-sdk-js'
import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useSearchParams } from "react-router-dom";

import {
  createProviderLinkOnClose,
  createProviderLinkOnFailure,
  createProviderLinkOnInit,
  createProviderLinkOnSuccess,
} from "../../helpers/webViewCallback";

import { callBackendAPI } from "../../helpers/api";
// import Vezgo from '../vendors/vezgo';

function VezgoProvider({
  institutionId,
  providerData,
  mode,
  walletId,
  setLoading,
}) {
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme") || localStorage.getItem("theme");
  console.log({ providerData }, "providerData");

  useEffect(() => {
    window.analytics.track("provider_link_vezgo_page_view", {
      providerData,
    });
  }, []);

  useEffect(() => {
    async function fetchVezgoData() {
      const message = searchParams.get('message');
      const accountId = searchParams.get('account');
      console.log('message', message);
      if (providerData) {
        if (message === 'Success') {
          await userConnect(accountId, mode);
        } else {
          await fetchVezgo();
        }
      }
    }

    fetchVezgoData();
  }, [providerData]);

  const fetchVezgo = async () => {
    if (providerData) {
      setLoading(true);
      const tokenResponse = await callBackendAPI({
        path: "/provider_link/vezgo/get_token",
        method: "POST",
      });

      let action = 'connect';
      if (mode === 'fix') {
        action = 'reconnect';
      }

      const vezgoURL = new URL(
        `https://connect.vezgo.com/${action}/${providerData.institution_id}`,
      );

      const redirect_uri = process.env.REACT_APP_PROVIDER_BASE_URL;

      // Use URLSearchParams to manage query parameters
      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_VEZGO_CLIENT_ID,
        token: tokenResponse.token,
        theme: theme,
        redirect_uri: redirect_uri,
      });

      // Append search parameters to the URL
      vezgoURL.search = params.toString();

      // Use the URL with the parameters for navigation
      window.location.href = vezgoURL.href;
    }
  };

  const userConnect = async (accountId, mode = "") => {
    createProviderLinkOnInit();
    if (mode === 'fix') {
      const getVezgoDetails = await callBackendAPI({
        path: `/provider_link/vezgo/get_account?user_wallet_id=${walletId}`,
        method: 'GET',
      });
      window.analytics.track('provider_link_vezgo_provider_fix_init', {
        target: 'providerLink',
        walletId,
        providerData,
      });
      window.analytics.track('provider_link_vezgo_provider_reconnect_start', {
        target: 'providerLink',
        walletId,
        providerData,
      });
      try {
        console.log('vezgo connection success:');
        const vezgoRes = await callBackendAPI({
          path: '/provider_link/fix_link',
          method: 'POST',
          body: {
            link_id: getVezgoDetails.id, // vezgo id
            link_type: providerData.wallet_type, // wallet type
            public_token: '', //
            link_token: '', //
          },
        });
        console.log(vezgoRes, 'vezgoRes');
        if (vezgoRes.success)
          createProviderLinkOnSuccess({
            message: 'Account re-connected successfully',
            walletId: vezgoRes.user_wallet_id,
          });
        window.analytics.track('provider_link_success', {
          source: 'vezgo_provider_reconnect',
          target: 'providerLink',
          walletId: vezgoRes.user_wallet_id,
          providerData,
        });
      } catch (err) {
        Sentry.captureException(err);

        console.log(JSON.stringify(err));
        window.analytics.track('provider_link_failure', {
          source: 'vezgo_provider_reconnect_error',
          target: 'providerLink',
          err,
          providerData,
        });
        createProviderLinkOnFailure({
          message: 'An error occured, please try again',
        });
      }
    } else {
      console.log('vezgo connection success:', accountId);
      const vezgoRes = await callBackendAPI({
        path: '/provider_link/create_link',
        method: 'POST',
        body: {
          link_type: providerData.wallet_type,
          provider_id: providerData.id,
          public_token: '',
          subtype: '',
          address: accountId,
          access_token: '',
        },
      });
      createProviderLinkOnSuccess({
        message: 'Account connected successfully',
        walletId: vezgoRes.user_wallet_id,
      });
      window.analytics.track('provider_link_success', {
        source: 'vezgo_provider_account_connect',
        target: 'providerLink',
        walletId: vezgoRes.user_wallet_id,
        providerData,
      });
    }
  };
  return <div>{/* <h1>Vezgo Provider</h1> */}</div>;
}

export default VezgoProvider;
